import { axiosTokenSetup } from 'config/axios';

import * as CST from './constants';

const emptyUser = {};
const userInfo = JSON.parse(localStorage.getItem(CST.USER_INFO));
const initialState = userInfo || emptyUser;
axiosTokenSetup(initialState);

export default function (state = initialState, action) {
  switch (action.type) {
    case CST.AUTHENTICATE_USER: {
      const user = {
        ...action.payload.user,
        info: JSON.parse(action.payload.user.resource),
      };
      saveUserToLocalStorage(user);
      return user;
    }
    case CST.REVOKE_USER:
      return { ...emptyUser };
    case CST.USER_UPDATED: {
      const user = {
        ...state,
        info: { ...action.payload },
      };
      saveUserToLocalStorage(user);
      return user;
    }
    default:
      return state;
  }
}

///////////////////////////////////////
//              HELPERS              //
///////////////////////////////////////

const saveUserToLocalStorage = user => (
  localStorage.setItem(CST.USER_INFO, JSON.stringify(user))
);



// WEBPACK FOOTER //
// ./src/reducers/user/reducer.js